"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Event = exports.default = void 0;

var _react = babelHelpers.interopRequireWildcard(require("react"));

var _reactDom = babelHelpers.interopRequireDefault(require("react-dom"));

var _classList = babelHelpers.interopRequireDefault(require("class-list"));

var _base = require("modals/base");

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var _decorators = require("decorators");

var _fetch = babelHelpers.interopRequireDefault(require("fetch"));

var _userProfile = require("user-profile");

var _noty = require("noty");

var _animationHelper = require("animation-helper");

var _momentTimezone = babelHelpers.interopRequireDefault(require("moment-timezone"));

var _SiteLayout = babelHelpers.interopRequireDefault(require("layouts/SiteLayout"));

var _class, _temp, _class3, _class4, _descriptor, _temp2, _class8, _class9;

var NoOp = function NoOp() {};

var EventModal =
/*#__PURE__*/
function (_ReactModal) {
  babelHelpers.inherits(EventModal, _ReactModal);

  function EventModal() {
    var _this;

    babelHelpers.classCallCheck(this, EventModal);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(EventModal).call(this));
    _this.removeOnHide = true;
    _this.classList = _this.classList.concat('survey-modal');

    _this.setComponent(_react.default.createElement(Event, {
      modal: babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this))
    }));

    return _this;
  }

  return EventModal;
}(_base.ReactModal);

exports.default = EventModal;
var Event = (_class = (_temp =
/*#__PURE__*/
function (_Component) {
  babelHelpers.inherits(Event, _Component);

  function Event() {
    var _babelHelpers$getProt;

    var _this2;

    babelHelpers.classCallCheck(this, Event);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt = babelHelpers.getPrototypeOf(Event)).call.apply(_babelHelpers$getProt, [this].concat(args)));
    _this2.state = {
      submissionComplete: false,
      submitting: false,
      title: "",
      startTime: _momentTimezone.default.tz(Date.now(), _momentTimezone.default.tz.guess()).startOf('day').add(1, 'day').add(8, 'hour').valueOf(),
      endTime: _momentTimezone.default.tz(Date.now(), _momentTimezone.default.tz.guess()).startOf('day').add(1, 'day').add(9, 'hour').valueOf(),
      timezone: _momentTimezone.default.tz.guess(),
      // allDay:       false,
      locationName: "",
      address: "",
      summary: ""
    };
    return _this2;
  }

  babelHelpers.createClass(Event, [{
    key: "setValue",
    value: function setValue(questionId, answer) {
      if (questionId == 'timezone') {
        var f = ['year', 'month', 'date', 'hour', 'minute'];

        var originalStartDate = _momentTimezone.default.tz(this.state.startTime, this.state.timezone);

        var originalEndDate = _momentTimezone.default.tz(this.state.endTime, this.state.timezone);

        var osdf = {},
            oedf = {};
        f.forEach(function (v) {
          osdf[v] = originalStartDate[v]();
          oedf[v] = originalEndDate[v]();
        });

        var nsd = _momentTimezone.default.tz(osdf, answer);

        var ned = _momentTimezone.default.tz(oedf, answer);

        this.setState({
          timezone: answer,
          startTime: nsd.valueOf(),
          endTime: ned.valueOf()
        });
      } else {
        this.setState(babelHelpers.defineProperty({}, questionId, answer));
      }
    }
  }, {
    key: "canSubmit",
    value: function canSubmit() {
      if (this.submitting) return false;
      var _this$state = this.state,
          title = _this$state.title,
          startTime = _this$state.startTime,
          endTime = _this$state.endTime,
          timezone = _this$state.timezone,
          locationName = _this$state.locationName,
          address = _this$state.address,
          summary = _this$state.summary;
      if (!title) return false;
      if (startTime < this.minimumValue) return false;
      if (endTime < startTime) return false;
      return true;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      this.props.modal.element.firstElementChild.addEventListener('scroll', function () {
        _this3.tempScrollPosition = _this3.props.modal.element.firstElementChild.scrollTop;
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.props.modal.element.firstElementChild.scrollTop = this.tempScrollPosition;
    }
  }, {
    key: "render",
    value: function render() {
      return _react.default.createElement("form", {
        className: "survey-body",
        onSubmit: this.submitEvent
      }, this.state.error && _react.default.createElement("div", {
        className: "alert alert-danger"
      }, this.state.error === true ? 'An error occurred submitting your event. Try again later.' : this.state.error), _react.default.createElement(EventItem, {
        type: "header",
        text: "Suggest an Event"
      }), _react.default.createElement(EventItem, {
        id: "title",
        required: true,
        type: "textField",
        text: "Event Title",
        setValue: this.setValue,
        value: this.state.title || "",
        disabled: this.state.submitting
      }), _react.default.createElement("div", {
        className: "event-item-row form-group"
      }, _react.default.createElement(EventItem, {
        id: "startTime",
        required: true,
        minimumValue: this.minimumValue,
        text: "Starts",
        type: this.state.allDay ? 'date' : 'dateTime',
        value: this.state.startTime,
        timeZone: this.state.timezone,
        setValue: this.setValue,
        disabled: this.state.submitting
      }), _react.default.createElement(EventItem, {
        id: "endTime",
        required: true,
        minimumValue: this.state.startTime,
        text: "Ends",
        type: this.state.allDay ? 'date' : 'dateTime',
        value: this.state.endTime,
        timeZone: this.state.timezone,
        setValue: this.setValue,
        disabled: this.state.submitting
      }), _react.default.createElement(EventItem, {
        id: "timezone",
        required: true,
        type: "timezone",
        text: "Time zone",
        currentTime: this.state.startTime,
        value: this.state.timezone,
        setValue: this.setValue,
        disabled: this.state.submitting
      })), false && _react.default.createElement(EventItem, {
        id: "allDay",
        value: this.state.allDay,
        setValue: this.setValue,
        type: "checkbox",
        text: "All day",
        disbled: this.state.submitting
      }), _react.default.createElement(EventItem, {
        id: "locationName",
        type: "textField",
        text: "Location Title",
        value: this.state.locationName,
        setValue: this.setValue,
        disabled: this.state.submitting
      }), _react.default.createElement(EventItem, {
        id: "address",
        type: "textField",
        multiline: true,
        text: "Address",
        value: this.state.address,
        setValue: this.setValue,
        disabled: this.state.submitting
      }), _react.default.createElement(EventItem, {
        id: "summary",
        type: "textField",
        multiline: true,
        text: "Summary",
        value: this.state.summary,
        setValue: this.setValue,
        disabled: this.state.submitting
      }), _react.default.createElement("div", {
        className: "form-submit"
      }, _react.default.createElement("button", {
        className: "btn btn-primary",
        disabled: !this.canSubmit()
      }, "Submit")));
    }
  }, {
    key: "submitEvent",
    value: function submitEvent(event) {
      var _this4 = this;

      event.preventDefault();

      if (this.state.submitting) {
        return;
      }

      this.setState({
        error: false,
        submitting: true
      }, function () {
        var _this4$state = _this4.state,
            title = _this4$state.title,
            startTime = _this4$state.startTime,
            endTime = _this4$state.endTime,
            timezone = _this4$state.timezone,
            locationName = _this4$state.locationName,
            address = _this4$state.address,
            summary = _this4$state.summary;
        (0, _fetch.default)("data/event/post", {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            title: title,
            startTime: startTime,
            endTime: endTime,
            timezone: timezone,

            /* allDay, */
            locationName: locationName,
            address: address,
            summary: summary
          })
        }).then(function (result) {
          if (result.ok) {
            return result.status == 204 ? true : result.json();
          }

          return result.json().then(function (value) {
            throw value;
          });
        }).then(function (value) {
          (0, _noty.showNotificationText)('Your event has been submitted.');

          _this4.props.modal.hide();

          _SiteLayout.default.current.navigate(value.location);
        }).catch(function (e) {
          if (e.isInvalidItem) {
            _this4.setState({
              error: 'Please fill out all required questions.',
              submitting: false
            });
          } else {
            _this4.setState({
              error: true,
              submitting: false
            });
          }
        });
      });
    }
  }, {
    key: "minimumValue",
    get: function get() {
      var timezone = this.state.timezone;

      var minStart = _momentTimezone.default.tz(Date.now(), timezone); // if (allDay) {
      //	minStart = moment.tz(Date.now(), timezone).startOf('day').add(1, 'day');
      // }


      return minStart.valueOf();
    }
  }]);
  return Event;
}(_react.Component), _temp), (babelHelpers.applyDecoratedDescriptor(_class.prototype, "setValue", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "setValue"), _class.prototype), babelHelpers.applyDecoratedDescriptor(_class.prototype, "submitEvent", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class.prototype, "submitEvent"), _class.prototype)), _class);
exports.Event = Event;

var EventItem = function EventItem(props) {
  var Type = Event[props.type];
  return _react.default.createElement(Type, props);
};

Event.header = function (_ref) {
  var text = _ref.text;
  return _react.default.createElement("h1", null, text);
};

Event.displayedText = function (_ref2) {
  var text = _ref2.text;
  return _react.default.createElement("p", null, text);
};

Event.dropdown = (_class3 =
/*#__PURE__*/
function (_Component2) {
  babelHelpers.inherits(_class3, _Component2);

  function _class3() {
    babelHelpers.classCallCheck(this, _class3);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_class3).apply(this, arguments));
  }

  babelHelpers.createClass(_class3, [{
    key: "setValue",
    value: function setValue(event) {
      this.props.setValue(this.props.id, event.target.value);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          id = _this$props.id,
          text = _this$props.text,
          required = _this$props.required,
          options = _this$props.options,
          disabled = _this$props.disabled;
      return _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("label", {
        htmlFor: "question_".concat(id)
      }, text, required && " ", required && _react.default.createElement("span", {
        className: "required"
      }, "*")), _react.default.createElement("select", {
        className: "form-control",
        name: id,
        id: "question_".concat(id),
        onChange: this.setValue,
        value: this.props.value,
        disabled: disabled
      }, options.map(function (_ref3) {
        var _ref4 = babelHelpers.slicedToArray(_ref3, 2),
            key = _ref4[0],
            value = _ref4[1];

        return _react.default.createElement("option", {
          key: key,
          value: key
        }, value);
      })), _react.default.createElement("span", null));
    }
  }]);
  return _class3;
}(_react.Component), (babelHelpers.applyDecoratedDescriptor(_class3.prototype, "setValue", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class3.prototype, "setValue"), _class3.prototype)), _class3);
var ZoneList = {
  "Pago Pago": "Pacific/Pago_Pago",
  "Hawaii Time": "Pacific/Honolulu",
  "Pacific Time": "America/Los_Angeles",
  "Pacific Time - Tijuana": "America/Tijuana",
  "Mountain Time": "America/Denver",
  "Mountain Time - Arizona": "America/Phoenix",
  "Mountain Time - Chihuahua, Mazatlan": "America/Mazatlan",
  "Central Time": "America/Chicago",
  "Central Time - Mexico City": "America/Mexico_City",
  "Central Time - Regina": "America/Regina",
  "Guatemala": "America/Guatemala",
  "Bogota": "America/Bogota",
  "Eastern Time": "America/New_York",
  "Lima": "America/Lima",
  "Caracas": "America/Caracas",
  "Atlantic Time - Halifax": "America/Halifax",
  "Guyana": "America/Guyana",
  "La Paz": "America/La_Paz",
  "Buenos Aires": "America/Argentina/Buenos_Aires",
  "Godthab": "America/Godthab",
  "Montevideo": "America/Montevideo",
  "Newfoundland Time - St. Johns": "America/St_Johns",
  "Santiago": "America/Santiago",
  "Sao Paulo": "America/Sao_Paulo",
  "South Georgia": "Atlantic/South_Georgia",
  "Azores": "Atlantic/Azores",
  "Cape Verde": "Atlantic/Cape_Verde",
  "Casablanca": "Africa/Casablanca",
  "Dublin": "Europe/Dublin",
  "Lisbon": "Europe/Lisbon",
  "London": "Europe/London",
  "Monrovia": "Africa/Monrovia",
  "Algiers": "Africa/Algiers",
  "Amsterdam": "Europe/Amsterdam",
  "Berlin": "Europe/Berlin",
  "Brussels": "Europe/Brussels",
  "Budapest": "Europe/Budapest",
  "Central European Time - Belgrade": "Europe/Belgrade",
  "Central European Time - Prague": "Europe/Prague",
  "Copenhagen": "Europe/Copenhagen",
  "Madrid": "Europe/Madrid",
  "Paris": "Europe/Paris",
  "Rome": "Europe/Rome",
  "Stockholm": "Europe/Stockholm",
  "Vienna": "Europe/Vienna",
  "Warsaw": "Europe/Warsaw",
  "Athens": "Europe/Athens",
  "Bucharest": "Europe/Bucharest",
  "Cairo": "Africa/Cairo",
  "Jerusalem": "Asia/Jerusalem",
  "Johannesburg": "Africa/Johannesburg",
  "Helsinki": "Europe/Helsinki",
  "Kiev": "Europe/Kiev",
  "Moscow-01 - Kaliningrad": "Europe/Kaliningrad",
  "Riga": "Europe/Riga",
  "Sofia": "Europe/Sofia",
  "Tallinn": "Europe/Tallinn",
  "Vilnius": "Europe/Vilnius",
  "Istanbul": "Europe/Istanbul",
  "Baghdad": "Asia/Baghdad",
  "Nairobi": "Africa/Nairobi",
  "Minsk": "Europe/Minsk",
  "Riyadh": "Asia/Riyadh",
  "Moscow+00 - Moscow": "Europe/Moscow",
  "Tehran": "Asia/Tehran",
  "Baku": "Asia/Baku",
  "Moscow+01 - Samara": "Europe/Samara",
  "Tbilisi": "Asia/Tbilisi",
  "Yerevan": "Asia/Yerevan",
  "Kabul": "Asia/Kabul",
  "Karachi": "Asia/Karachi",
  "Moscow+02 - Yekaterinburg": "Asia/Yekaterinburg",
  "Tashkent": "Asia/Tashkent",
  "Colombo": "Asia/Colombo",
  "Almaty": "Asia/Almaty",
  "Dhaka": "Asia/Dhaka",
  "Rangoon": "Asia/Rangoon",
  "Bangkok": "Asia/Bangkok",
  "Jakarta": "Asia/Jakarta",
  "Moscow+04 - Krasnoyarsk": "Asia/Krasnoyarsk",
  "China Time - Beijing": "Asia/Shanghai",
  "Hong Kong": "Asia/Hong_Kong",
  "Kuala Lumpur": "Asia/Kuala_Lumpur",
  "Moscow+05 - Irkutsk": "Asia/Irkutsk",
  "Singapore": "Asia/Singapore",
  "Taipei": "Asia/Taipei",
  "Ulaanbaatar": "Asia/Ulaanbaatar",
  "Western Time - Perth": "Australia/Perth",
  "Moscow+06 - Yakutsk": "Asia/Yakutsk",
  "Seoul": "Asia/Seoul",
  "Tokyo": "Asia/Tokyo",
  "Central Time - Darwin": "Australia/Darwin",
  "Eastern Time - Brisbane": "Australia/Brisbane",
  "Guam": "Pacific/Guam",
  "Moscow+07 - Magadan": "Asia/Magadan",
  "Moscow+07 - Yuzhno-Sakhalinsk": "Asia/Vladivostok",
  "Port Moresby": "Pacific/Port_Moresby",
  "Central Time - Adelaide": "Australia/Adelaide",
  "Eastern Time - Hobart": "Australia/Hobart",
  "Eastern Time - Melbourne, Sydney": "Australia/Sydney",
  "Guadalcanal": "Pacific/Guadalcanal",
  "Noumea": "Pacific/Noumea",
  "Majuro": "Pacific/Majuro",
  "Moscow+09 - Petropavlovsk-Kamchatskiy": "Asia/Kamchatka",
  "Auckland": "Pacific/Auckland",
  "Fakaofo": "Pacific/Fakaofo",
  "Fiji": "Pacific/Fiji",
  "Tongatapu": "Pacific/Tongatapu",
  "Apia": "Pacific/Apia"
};
Event.timezone = (_class4 = (_temp2 =
/*#__PURE__*/
function (_Component3) {
  babelHelpers.inherits(_class4, _Component3);

  function _class4() {
    var _babelHelpers$getProt2;

    var _this5;

    babelHelpers.classCallCheck(this, _class4);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _this5 = babelHelpers.possibleConstructorReturn(this, (_babelHelpers$getProt2 = babelHelpers.getPrototypeOf(_class4)).call.apply(_babelHelpers$getProt2, [this].concat(args)));
    babelHelpers.initializerDefineProperty(_this5, "currentTime", _descriptor, babelHelpers.assertThisInitialized(babelHelpers.assertThisInitialized(_this5)));
    _this5._zoneData = {};
    _this5._zoneCache = {};
    return _this5;
  }

  babelHelpers.createClass(_class4, [{
    key: "render",
    value: function render() {
      if (!this._zoneData[this.currentTime]) {
        var m = (0, _momentTimezone.default)(this.currentTime);
        var zl = Object.keys(ZoneList).map(function (name) {
          return [Number(m.tz(ZoneList[name]).format('ZZ')), ZoneList[name], "(GMT".concat(m.tz(ZoneList[name]).format('Z'), ") ").concat(name)];
        });
        zl.sort(function (left, right) {
          return left[0] - right[0];
        });
        zl = zl.map(function (_ref5) {
          var _ref6 = babelHelpers.slicedToArray(_ref5, 3),
              x = _ref6[0],
              a = _ref6[1],
              b = _ref6[2];

          return [a, b];
        });
        var k = JSON.stringify(zl);
        if (this._zoneCache[k]) zl = this._zoneCache[k];
        this._zoneData[this.currentTime] = zl;
      }

      var Dropdown = Event.dropdown;
      return _react.default.createElement(Dropdown, {
        id: this.props.id,
        text: this.props.text,
        setValue: this.props.setValue,
        required: this.props.required,
        options: this._zoneData[this.currentTime],
        disabled: this.props.disabled,
        value: this.props.value
      });
    }
  }]);
  return _class4;
}(_react.Component), _temp2), (_descriptor = babelHelpers.applyDecoratedDescriptor(_class4.prototype, "currentTime", [_decorators.prop], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class4);

Event.checkbox =
/*#__PURE__*/
function (_Component4) {
  babelHelpers.inherits(_class6, _Component4);

  function _class6() {
    babelHelpers.classCallCheck(this, _class6);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_class6).apply(this, arguments));
  }

  babelHelpers.createClass(_class6, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", null);
    }
  }]);
  return _class6;
}(_react.Component);

Event.date =
/*#__PURE__*/
function (_Component5) {
  babelHelpers.inherits(_class7, _Component5);

  function _class7() {
    babelHelpers.classCallCheck(this, _class7);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_class7).apply(this, arguments));
  }

  babelHelpers.createClass(_class7, [{
    key: "render",
    value: function render() {
      return _react.default.createElement("div", null);
    }
  }]);
  return _class7;
}(_react.Component);

Event.dateTime = (_class8 =
/*#__PURE__*/
function (_Component6) {
  babelHelpers.inherits(_class8, _Component6);

  function _class8() {
    babelHelpers.classCallCheck(this, _class8);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_class8).apply(this, arguments));
  }

  babelHelpers.createClass(_class8, [{
    key: "setValue",
    value: function setValue(event) {
      var theValue = new Date(event.target.value);

      var d = _momentTimezone.default.tz({
        year: theValue.getFullYear(),
        month: theValue.getMonth(),
        date: theValue.getDate(),
        hour: theValue.getHours(),
        minute: theValue.getMinutes()
      }, this.props.timeZone);

      this.props.setValue(this.props.id, d.valueOf());
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          id = _this$props2.id,
          required = _this$props2.required,
          minimumValue = _this$props2.minimumValue,
          text = _this$props2.text,
          value = _this$props2.value,
          timeZone = _this$props2.timeZone,
          disabled = _this$props2.disabled;
      return _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("label", {
        htmlFor: "question_".concat(id)
      }, text, required && " ", required && _react.default.createElement("span", {
        className: "required"
      }, "*")), _react.default.createElement("input", {
        type: "text",
        className: "form-control",
        required: required,
        disabled: disabled,
        ref: this.gotField
      }));
    }
  }, {
    key: "setFieldValue",
    value: function setFieldValue() {
      if (this._inputField) {
        var m = _momentTimezone.default.tz(this.props.value, this.props.timeZone);

        this._inputField.value = m.format('MMMM D, YYYY h:mm A');
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value != this.props.value || prevProps.timeZone != this.props.timeZone) {
        this.setFieldValue();
      }
    }
  }, {
    key: "gotField",
    value: function gotField(field) {
      this._inputField = field;

      if (field) {
        this.setFieldValue();
        $(field).change(this.setValue).datetimepicker({
          mode: 'datetime',
          hideTime: false
        });
      }
    }
  }]);
  return _class8;
}(_react.Component), (babelHelpers.applyDecoratedDescriptor(_class8.prototype, "setValue", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class8.prototype, "setValue"), _class8.prototype), babelHelpers.applyDecoratedDescriptor(_class8.prototype, "gotField", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class8.prototype, "gotField"), _class8.prototype)), _class8);
Event.textField = (_class9 =
/*#__PURE__*/
function (_Component7) {
  babelHelpers.inherits(_class9, _Component7);

  function _class9() {
    babelHelpers.classCallCheck(this, _class9);
    return babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(_class9).apply(this, arguments));
  }

  babelHelpers.createClass(_class9, [{
    key: "setValue",
    value: function setValue(event) {
      this.props.setValue(this.props.id, event.target.value);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.value != this.props.value && this.fakeElement && this.commentField) {
        this.updateSize();
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateSize();
    }
  }, {
    key: "gotCommentField",
    value: function gotCommentField(node) {
      this.commentField = node;
    }
  }, {
    key: "gotFakeElement",
    value: function gotFakeElement(node) {
      this.fakeElement = node;
    }
  }, {
    key: "updateSize",
    value: function updateSize() {
      var _this6 = this;

      if (this.fakeElement && this.commentField) {
        var v = this.props.value || "";
        var nl = this.fakeElement.childNodes;
        var cStyle = window.getComputedStyle(this.commentField);
        ['boxSizing', 'paddingTop', 'paddingBottom', 'paddingLeft', 'paddingRight', 'borderTopWidth', 'borderLeftWidth', 'borderRightWidth', 'borderBottomWidth', 'whiteSpace', 'fontFamily', 'fontStyle', 'fontSize', 'fontWeight', 'lineHeight'].forEach(function (p) {
          return _this6.fakeElement.style[p] = cStyle[p];
        });
        this.fakeElement.style.position = 'fixed';
        this.fakeElement.style.right = '150%';
        v = v.split('\n');

        for (var i = 0; i < v.length; i++) {
          if (!nl[i]) this.fakeElement.appendChild(document.createElement('div'));
          nl[i].textContent = v[i] || '\xa0';
        }

        while (nl.length > v.length) {
          this.fakeElement.removeChild(nl[nl.length - 1]);
        }

        var w,
            tgtH,
            rowCount = this.commentFieldMinLines;

        do {
          w = this.commentField.clientWidth;
          console.log(this.fakeElement.style.width = this.fakeElement.style.boxSizing == 'border-box' ? "".concat(w, "px") : "calc(".concat(w, "px - ").concat(cStyle.paddingLeft, " - ").concat(cStyle.paddingRight, " - ").concat(cStyle.borderLeftWidth, " - ").concat(cStyle.borderRightWidth, ")"));
          tgtH = this.fakeElement.offsetHeight;
          console.log(this.commentField.style.height = this.fakeElement.style.boxSizing == 'border-box' ? "calc(".concat(tgtH, "px + 2px)") : "calc(".concat(tgtH, "px - ").concat(cStyle.paddingTop, " - ").concat(cStyle.paddingBottom, " - ").concat(cStyle.borderTopWidth, " - ").concat(cStyle.borderBottomWidth, " + 2px)"));
        } while (w != this.commentField.clientWidth);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          id = _this$props3.id,
          text = _this$props3.text,
          required = _this$props3.required,
          options = _this$props3.options,
          disabled = _this$props3.disabled,
          multiline = _this$props3.multiline;
      return _react.default.createElement("div", {
        className: "form-group"
      }, _react.default.createElement("label", {
        htmlFor: "question_".concat(id)
      }, text, required && " ", required && _react.default.createElement("span", {
        className: "required"
      }, "*")), !multiline && _react.default.createElement("input", {
        type: "text",
        className: "form-control",
        name: id,
        id: "question_".concat(id),
        value: this.props.value,
        onChange: this.setValue,
        disabled: disabled
      }), multiline && _react.default.createElement("textarea", {
        ref: this.gotCommentField,
        className: "form-control",
        name: id,
        id: "question_".concat(id),
        rows: "3",
        value: this.props.value,
        onChange: this.setValue,
        disabled: disabled
      }), multiline && _react.default.createElement("div", {
        className: _classList.default.join('fake-textarea', this.props.value ? '' : 'fake-textarea-placeholder'),
        ref: this.gotFakeElement
      }));
    }
  }]);
  return _class9;
}(_react.Component), (babelHelpers.applyDecoratedDescriptor(_class9.prototype, "setValue", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "setValue"), _class9.prototype), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "gotCommentField", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "gotCommentField"), _class9.prototype), babelHelpers.applyDecoratedDescriptor(_class9.prototype, "gotFakeElement", [_decorators.autobind], Object.getOwnPropertyDescriptor(_class9.prototype, "gotFakeElement"), _class9.prototype)), _class9);